import get from 'lodash/get';
import { getStateSliceFor } from 'redux/Studio';
import { studioFeedbackReducerKey } from './reducer';
// =========
// SELECTORS
// =========
const ownSlice = state => getStateSliceFor({ state, reducerKey: studioFeedbackReducerKey });

export const getIsFeedbackOpen = ({ state }) => {
  return ownSlice(state).isFeedbackOpen;
};

export const getSelectedFeedbackItem = ({ state }) => {
  const stateSlice = ownSlice(state);
  return get(stateSlice, `feedbackItems.${stateSlice.selectedFeedbackItem}`, null);
};

export const getFeedbackItem = ({ id, state }) => {
  return get(ownSlice(state), `feedbackItems.${id}`);
};
